export default class ActivityViewModel {
    work_orders_id: number;
    subject_activities: string;
    date_start_at: string;
    time_start_at: string;
    date_end_at: string;
    time_end_at: string;
    duration_time: string;
    technicians: {
        id: number;
        is_pic: boolean; 
        name: string;
        photo: string;
    }[];
    report_explanation: string;
    attachments: {
        path: string;
        label: string;
    }[];
    issued_by_users_id: number;
    constructor(data: Partial<ActivityViewModel> = {}) {
        this.work_orders_id = data.work_orders_id || 0;
        this.subject_activities = data.subject_activities || "";
        this.date_start_at = data.date_start_at || "";
        this.time_start_at = data.time_start_at || "";
        this.date_end_at = data.date_end_at || "";
        this.time_end_at = data.time_end_at || "";
        this.duration_time = data.duration_time || "";
        this.technicians = data.technicians || [];
        this.report_explanation = data.report_explanation || "";
        this.attachments = data.attachments || [];
        this.issued_by_users_id = data.issued_by_users_id || 0;
    }
}
